import type { Location } from '@remix-run/router';

export const isLinkActive = (url: string, location: Location<any>) => {
  return location.pathname === url;
};
